import { createApp } from "vue";
// import Antd from "ant-design-vue";
import App from "./App.vue";
import router from "./router";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import "ant-design-vue/dist/antd.variable.min.css";
import "@/assets/scss/app.scss";
import vDrag from "@/directives/v-drag";
import vReClick from "@/directives/v-reclick";
import vPermission from "@/directives/v-permission";
import vResize from "@/directives/v-resize";
import vPreview from "@/directives/v-preview";
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

const app = createApp(App);
app.use(pinia).use(router).mount("#app");
// 防止重复点击
app.directive("reClick", vReClick);
// 权限判断
app.directive("permission", vPermission);
// 拖拽
app.directive("drag", vDrag);
// 拉伸
app.directive("resize", vResize);
// 图片预览
app.directive("preview", vPreview);
